var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBubbleChartWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Component 931 \\u2013 20",
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.225,
    height: 28.328,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 37299"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 37302",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21667",
    d: "M27.225 28.329H1.945A1.945 1.945 0 0 1 0 26.384V1.104h1.945v25.28h25.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21651",
    d: "M21.198 15.495a1.722 1.722 0 1 1-1.718-1.722 1.722 1.722 0 0 1 1.718 1.722Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21652",
    d: "M15.173 8.609a1.722 1.722 0 1 1-1.722-1.722 1.722 1.722 0 0 1 1.722 1.722Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21653",
    d: "M27.224 14.634a.861.861 0 1 1-.861-.861.861.861 0 0 1 .861.861Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21654",
    d: "M24.211 24.102a3.013 3.013 0 1 1 3.012-3.013 3.013 3.013 0 0 1-3.012 3.013Zm0-4.3a1.292 1.292 0 1 0 1.292 1.292 1.292 1.292 0 0 0-1.292-1.292Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21655",
    d: "M13.451 24.103a3.407 3.407 0 0 1-1.83-.535 6.024 6.024 0 1 1 3.538-5.886 3.436 3.436 0 0 1-1.708 6.421Zm-1.621-2.606.464.426a1.715 1.715 0 1 0 1.725-2.878l-.595-.209.026-.729a4.311 4.311 0 1 0-2.167 3.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21656",
    d: "M22.059 12.051a5.171 5.171 0 0 1-5.165-5.165 4.588 4.588 0 0 1 .023-.46 3.4 3.4 0 0 1-1.744-2.982A3.448 3.448 0 0 1 18.616.001 3.4 3.4 0 0 1 21.6 1.746c.156-.015.308-.023.459-.023a5.165 5.165 0 0 1 0 10.329ZM18.616 1.723a1.723 1.723 0 0 0-1.722 1.722 1.7 1.7 0 0 0 1.231 1.636l.777.233-.185.79a3.488 3.488 0 1 0 2.556-2.56l-.788.184-.231-.777a1.7 1.7 0 0 0-1.638-1.228Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21657",
    d: "M6.996 7.751a3.874 3.874 0 1 1 3.876-3.877 3.874 3.874 0 0 1-3.876 3.877Zm0-6.025a2.152 2.152 0 1 0 2.151 2.148 2.152 2.152 0 0 0-2.151-2.152Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBubbleChartWhite);
export default __webpack_public_path__ + "static/media/bubble-chart-white.204b4925a6e661e2aa70b192ff737571.svg";
export { ForwardRef as ReactComponent };